var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"counter-wrapper"},[_c('span',{staticClass:"counter-number"},[_vm._v(_vm._s(_vm.displayValue))]),_c('span',{staticClass:"counter-label"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }